/**
 * 登录页相关action
 */
// import fetch from 'isomorphic-fetch'
import oData from '../server/odata_client';
import oDataSystem from '../server/odataSystem';
import Store from '../script/store';
import Base64 from '../script/base64.js';
import Utils from '../script/utils';
import ServerEquipment from '../server/serverEquipment';
import rData from '../server/rest_client';
// OFBiz 新接口客户端（鉴权基座）
import * as ofbiz from '../server/ofbiz';

import { createOperationAudit } from './operationAudit_action';

export const SET_LOGIN_ERROR_MSG = 'SET_LOGIN_ERROR_MSG';
// export const GET_TOKEN = 'GET_TOKEN'
// export const GET_SELECTEDROLEPERMISSION = 'GET_SELECTEDROLEPERMISSION'
export const SET_LOGIN_TOURL = 'SET_LOGIN_TOURL'; //
export const SET_LOGIN_TYPE = 'SET_LOGIN_TYPE'; //
export const SET_NEED_SELECT_ROLE = 'SET_NEED_SELECT_ROLE'; //
export const SET_AUTHENTICATIONDATA = 'SET_AUTHENTICATIONDATA';
export const SET_LICENSELIST = 'SET_LICENSELIST';

export function setAuthenticationData(authenticationData) {
  return {
    type: SET_AUTHENTICATIONDATA,
    authenticationData
  }
}

export function setLicenseList(licenseList) {
  return {
    type: SET_LICENSELIST,
    licenseList
  }
}
export function setLoginErrorMsg(msg) {
    return {
        type: SET_LOGIN_ERROR_MSG,
        msg
    }
}
export function setNeedSelectRole(needSelectRole) {
  return {
    type:SET_NEED_SELECT_ROLE,
    needSelectRole
  }
}

export function setLoginType(loginType) {
    return {
        type: SET_LOGIN_TYPE,
        loginType
    }
}

//设置跳转路由
export function setToUrl(toUrl) {
    return {
        type: SET_LOGIN_TOURL,
        toUrl
    }
}

function getVersion() {
    oData.getVersion(function(data) {
        Store.set("Version",data);
    });
}

function receiveGetCurrentPermissions(data, callback, errorCallback) {
    return (dispatch, getState) => {
        if(!data){
            dispatch(setLoginErrorMsg('获取用户权限出错, 请重新登录。'));
            errorCallback && errorCallback({errorCode: 1, errmsg: '获取用户权限出错, 请重新登录。'});
            return;
        };
        if (data.errormsg == 'token invalid.') {
          errorCallback && errorCallback(data);
          return;
        }
        var state = getState();
        var permissions =  data.permission;
        // if(!permissionsValue.length && Store.get("CURRENT_ROLENAME") !== '管理员'){
        //     dispatch(setLoginErrorMsg('获取用户权限为空, 请重新登录。'));
        //     errorCallback && errorCallback();
        //     return;
        // };
        const permissionsArr = [];
        permissions.map(item => {
          if (permissionsArr.indexOf(item.Type) == -1) {
            permissionsArr.push(item.Type);
          }
        });
        let permissionsValue = encodeURI(permissionsArr.join(','));
        permissionsValue = Base64.base64encode(permissionsValue);
        Store.set("PERMISSIONS",permissionsValue);
        // document.location.reload();
        dispatch(setLoginErrorMsg(""));
        callback && callback();
    }
}

//登录 action
export function getToken(user, callback, errorCallback) {
  return dispatch => {
    // rData.getRolePermission(Store.get("CURRENT_ROLENAME"), data => dispatch(receiveGetCurrentPermissions(data, callback, errorCallback)));
    // return;
    Store.set('roles',"");
    //清除厅级项备份的数据项
    Store.set("DEPSTORAGEITEM",'');
    Store.set("DEPSTORAGEPERMITEM",'');
    Store.set("DEPSTORAGEURLITEM",'');
    // === 已切换到 OFBiz 新接口 ===
    // 旧接口 user.password 是 Base64(encodeURI(明文))；新接口 auth/login 要求明文 password，
    // 这里还原成明文再传。
    let plainPassword = user.password;
    try {
      plainPassword = Base64.base64decode(user.password);
    } catch (e) {
      plainPassword = user.password;
    }

    ofbiz.login(user.username, plainPassword).then(loginData => {
      // 新接口登录成功后由后端写 JSESSIONID Cookie，不再需要本地 token；
      // 为兼容旧代码里大量 Store.get('token') 的非空判断，置一个占位标记。
      Store.set("token", "ofbiz-session");

      // ⚠️ 兼容旧 OData 体系：登录后仍有大量旧代码通过 o.js 调 /bods.svc/
      // （如 getVersion、getOs、首页资源树等），必须初始化 OData endpoint，
      // 否则会抛 "You can not use resource query without defining your oData endpoint"。
      // 旧 getToken 里靠 path.json 的 ServiceAddress 初始化，这里沿用同一套配置。
      Store.getConfigJson((cfg) => {
        Store.set("serviceUrl", cfg.ServiceAddress);
        Store.set("tokenUrl", cfg.TokenVerify);
        Store.set("platformType", cfg.platformType);
        Store.set("servletServiceUrl", cfg.ServletServiceAddress);
        Store.set("newsamUrl", cfg.newsamUrl);
        Store.set("itossUrl", cfg.ServiceItoss);
        Store.set("mapUrl", cfg.mapUrl);
        Store.set("wsUrl", cfg.wsUrl);
        Store.set("dashboardUrl", cfg.dashboardUrl);
        Store.set("vlanUrl", cfg.vlanUrl);
        Store.set("mobileUrl", cfg.mobileUrl);
        // 初始化 OData 客户端 endpoint（关键，否则后续 OData 调用全部报错）
        oData.setOdataConfig();
      });

      // 登录成功后拉取用户信息（替代旧 queryGetUserInfo / getUserInfo）
      return ofbiz.authMe().then(userInfo => {
        // 兼容写入旧代码依赖的 Store 字段
        const info = userInfo || {};
        Store.set("USER_ID", info.userLoginId || info.userId || '');
        Store.set("USERNAME", info.userLoginId || info.username || user.username);
        Store.set("localUserName", info.userLoginId || user.username);
        // 角色：新接口可能返回 roleName / roles 数组 / role 对象
        let role = info.roleName || (Array.isArray(info.roles) && info.roles[0]) || info.roles || '';
        if (typeof role !== 'string') {
          role = (role && (role.roleName || role.name || role.roleId)) || '';
        }
        // hasPermission() 对 CURRENT_ROLENAME=='管理员' 直接放行全部菜单。
        // 新后端超级管理员角色名可能是英文(ADMIN/IT_ADMIN 等)，这里做兼容映射，
        // 确保超级管理员能看到所有菜单（避免权限数据缺失导致菜单全空）。
        const ADMIN_ROLE_NAMES = ['管理员', 'ADMIN', 'IT_ADMIN', 'SUPER_ADMIN', 'admin'];
        if (!role || ADMIN_ROLE_NAMES.indexOf(String(role).toUpperCase()) > -1 || ADMIN_ROLE_NAMES.indexOf(String(role)) > -1) {
          role = '管理员';
        }
        Store.set("CURRENT_ROLENAME", role);
        return info;
      });
    }).then(info => {
      getVersion();
      // multi_roles 多角色选择：新接口暂未提供，默认单角色直接进入
      Store.set("multi_roles", "0");
      window.treeLoadFlag = 0;

      // 权限：旧代码通过 rData.getRolePermission 写 PERMISSIONS。
      // 新接口体系下权限随 authMe 返回（info.permissions），这里兼容处理。
      const perms = info.permissions || [];
      if (perms.length) {
        const permsArr = [];
        perms.forEach(item => {
          const t = typeof item === 'string' ? item : (item.Type || item.permission || item.name);
          if (t && permsArr.indexOf(t) === -1) permsArr.push(t);
        });
        let permsValue = encodeURI(permsArr.join(','));
        permsValue = Base64.base64encode(permsValue);
        Store.set("PERMISSIONS", permsValue);
      }

      oDataSystem.getOs((os)=>{
          Store.set("osname",os);
      })

      callback && callback(info);
    }).catch(err => {
      errorCallback && errorCallback();
      const msg = (err && err.message) || '登录失败。';
      dispatch(setLoginErrorMsg(msg));
    });
  }
}

function receiveQueryGetUserInfo(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            // _this.errorMsg = '请求用户信息出错, 请重新登录。';
            // return;
            return dispatch(setLoginErrorMsg('请求用户信息出错, 请重新登录。'))
        };
        Store.set("USER_ID",data.results[0].USER_ID);
        Store.set("USERNAME",data.results[0].USERNAME);
        // Store.set("LEVEL",data.results[0].LEVEL);//1是厅级  2是市级
        Store.set("GROUP_NAME",data.results[0].GROUP_NAME);//安全群群组名
        Store.set("GROUP_ID",data.results[0].GROUP_ID);//安全群群组ID
        Store.set("DIAGNOSIS",data.results[0].DIAGNOSIS);//诊断平台地址
        Store.set("PHONE",data.results[0].PHONE);//用户手机
        Store.set("TELEPHONE",data.results[0].TELEPHONE);//固定电话
        //获取操作权限 filters 格试 [{key:"ROLE_NAME",value:""},{key:"GROUP_NAME",value:""}];
        var filters = [
            {key:"ROLE_NAME",value:Store.get("CURRENT_ROLENAME")},
            {key:"GROUP_NAME",value:Store.get("GROUP_NAME")},
            {key:"COMPANY",value:Store.get("platformType")}
        ];
        // document.location.reload();
        location.href = "#/home";
        // oData.GetCurrentPermissions(filters, data => dispatch(receiveGetCurrentPermissions(data)));
    }
}

function receiveSelectUserRole(data) {
    return dispatch => {
        if(data.flag == "0"){
            // _this.errorMsg = '角色验证失败, 请重新选择角色。';
            // _this.emit("change");
            // return;
            return dispatch(setLoginErrorMsg('角色验证失败, 请重新选择角色。'));
        };
        oData.queryGetUserInfo(Store.get("localUserName"), data => dispatch(receiveQueryGetUserInfo(data)));
    }
}

function oDataGetSelectUserRole(filters) {
    return dispatch => {
  		Store.set('roles',"")
  		oData.SelectUserRole(filters, data => dispatch(receiveSelectUserRole(data)));
    }
}

export function getSelectedRolePermission(callback) {
  return dispatch => {
      var role = Store.get("CURRENT_ROLENAME"), localUserName = Store.get("localUserName");
      Store.set('roles',"");
      const auditData = {
        type: 'login',
        BoId: 'user',
        Operator: localUserName,
        OperationDesc: `${localUserName}登录-设置${role}角色`
      }
  		ServerEquipment.SelectUserRole(role, data => {
        rData.getRolePermission(role, data2 => dispatch(receiveGetCurrentPermissions(data2, () => {
          callback && callback(data);
        }, callback)));
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
        // callback && callback(data);
      }, (res) => {
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
        callback && callback(res);
      });
  }
}

// 已切换到 OFBiz 新接口：通过 authMe 获取当前用户权限
// （/role/permissions 返回的是权限全集，不是当前用户权限，故不用它）
export function getRolePermission(callback){
  return dispatch => {
    ofbiz.authMe().then(userInfo => {
      // 兼容 receiveGetCurrentPermissions 期望的结构 { permission: [{Type}] }
      const perms = (userInfo && userInfo.permissions) || [];
      const adapted = {
        permission: perms.map(item => {
          // 兼容字符串或对象形式，统一取权限标识放入 Type
          const t = typeof item === 'string' ? item : (item.Type || item.permissionId || item.name || '');
          return { Type: t };
        })
      };
      dispatch(receiveGetCurrentPermissions(adapted, callback, callback));
    }).catch(err => {
      // 获取权限失败不阻断，按无权限处理
      dispatch(receiveGetCurrentPermissions({ permission: [] }, callback, callback));
    });
  }
}

export function logout(callback){
  return dispatch => {
    rData.logout((data)=>{
      Store.set('token','');
      callback && callback(true);
    }, (status) => {
      callback && callback(false);
    });
  }
}

export function getAuthData(callback) {
  return dispatch => {
    rData.getAuthenticationData((data)=>{
      callback && callback(true, data);
    }, (status) => {
      Utils.showMessageDialog('提示', `获取认证数据失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false, status);
    });
  }
}

//获取认证URL
export function getAuthenticationData(callback) {
  return dispatch => {
    rData.getAuthenticationData((data)=>{
      if (data.lic) {
        rData.getLicenseList((list) => {
          data.licDetail = list.find(d=>d.name == data.lic);
          dispatch(setAuthenticationData(data));
          callback && callback(true);
        }, (listStatus) => {
          dispatch(setAuthenticationData(data));
          callback && callback(true);
        });
      } else {
        dispatch(setAuthenticationData(data));
        callback && callback(true);
      }
    }, (status) => {
      Utils.showMessageDialog('提示', `获取认证数据失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false);
    });
  }
}

//更新认证URL
export function updateAuthenticationUrl(url, callback) {
  return dispatch => {
    if (url) {
      rData.updateAuthenticationUrl(url, (data) => {
        rData.unbindAuthenticationIP((data2) => {
          rData.unbindLicense((data3) => {
            callback && callback(true);
            Utils.showMessageDialog('提示', `更新认证URL成功`);
          }, (status3) => {
            Utils.showMessageDialog('提示', `解绑license失败${status3.errmsg?('，' + status3.errmsg):''}`);
            callback && callback(true);
          });
        }, (status2) => {
          Utils.showMessageDialog('提示', `解绑认证IP失败${status2.errmsg?('，' + status2.errmsg):''}`);
          callback && callback(true);
        });
      }, (status) => {
        Utils.showMessageDialog('提示', `更新认证URL失败${status.errmsg?('，' + status.errmsg):''}`);
        callback && callback(false);
      });
    } else {
      rData.unbindAuthenticationIP((data2) => {
        rData.unbindLicense((data3) => {
          rData.updateAuthenticationUrl(url, (data) => {
            callback && callback(true);
            Utils.showMessageDialog('提示', `更新认证URL成功`);
          }, (status) => {
            callback && callback(false);
            Utils.showMessageDialog('提示', `更新认证URL失败`);
          });
        }, (status3) => {
          Utils.showMessageDialog('提示', `解绑license失败${status3.errmsg?('，' + status3.errmsg):''}`);
          callback && callback(true);
        });
      }, (status2) => {
        Utils.showMessageDialog('提示', `解绑认证IP失败${status2.errmsg?('，' + status2.errmsg):''}`);
        callback && callback(true);
      });
    }
  }
}

//绑定认证IP
export function bindAuthenticationIP(callback) {
  return dispatch => {
    rData.bindAuthenticationIP((data) => {
      callback && callback(true);
      Utils.showMessageDialog('提示', `绑定认证IP成功`);
    }, (status) => {
      Utils.showMessageDialog('提示', `绑定认证IP失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false);
    });
  }
}

//解绑认证IP
export function unbindAuthenticationIP(callback) {
  return dispatch => {
    rData.unbindAuthenticationIP((data) => {
      rData.unbindLicense((data2) => {
        callback && callback(true);
        Utils.showMessageDialog('提示', `解绑认证IP成功`);
      }, (status2) => {
        Utils.showMessageDialog('提示', `解绑license失败${status2.errmsg?('，' + status2.errmsg):''}`);
        callback && callback(true);
      });
    }, (status) => {
      Utils.showMessageDialog('提示', `解绑认证IP失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false);
    });
  }
}

//获取license列表
export function getLicenseList(callback) {
  return dispatch => {
    rData.getLicenseList((data) => {
      function sortBy(a, b){
        return a.name.localeCompare(b.name);
      }
      data.sort(sortBy);
      dispatch(setLicenseList(data));
      callback && callback(true);
      // Utils.showMessageDialog('提示', `获取license列表成功`);
    }, (status) => {
      Utils.showMessageDialog('提示', `获取license列表失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false);
    });
  }
}

//绑定license
export function bindLicense(license, callback) {
  return dispatch => {
    rData.bindLicense(license, (data) => {
      callback && callback(true);
      Utils.showMessageDialog('提示', `绑定license成功`);
    }, (status) => {
      Utils.showMessageDialog('提示', `绑定license失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false);
    });
  }
}

//解绑license
export function unbindLicense(callback) {
  return dispatch => {
    rData.unbindLicense((data) => {
      callback && callback(true);
      Utils.showMessageDialog('提示', `解绑license成功`);
    }, (status) => {
      Utils.showMessageDialog('提示', `解绑license失败${status.errmsg?('，' + status.errmsg):''}`);
      callback && callback(false);
    });
  }
}
